class Picture extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      isReady: true
    }
  }

  render() {

    const src = this.props.src;
    const proHeight = this.props.proHeight ? "pro-height" : "";
    const isReady = this.state.isReady ? "ready" : "";
    const className = this.props.className ? this.props.className : "";
    const width = this.props.width ? this.props.width : 1000;

    return (
      <picture className={`${className} ${proHeight} ${isReady}`} ref="elem" style={{
        display: 'inline-block',
        fontSize: 0,
        lineHeight: 1
      }}>
        <source
          srcSet={`
            ${src}?q=100&w=${width}&fm=jpg&fl=progressive 1x,
            ${src}?q=100&w=${width * 1.5}&fm=jpg&fl=progressive 1.5x,
            ${src}?q=100&w=${width * 2}&fm=jpg&fl=progressive 2x`}
          media="(min-width: 80em)" />
        <source
          srcSet={`
            ${src}?q=100&w=${width * 0.8}&fm=jpg&fl=progressive 1x,
            ${src}?q=100&w=${width}&fm=jpg&fl=progressive 1.5x,
            ${src}?q=100&w=${width * 1.5}&fm=jpg&fl=progressive 2x
          `}
          media="(min-width: 50em)" />
        <source
          srcSet={`
            ${src}?q=100&w=400&fm=jpg&fl=progressive 1x,
            ${src}?q=100&w=600&fm=jpg&fl=progressive 1.5x,
            ${src}?q=100&w=800&fm=jpg&fl=progressive 2x
          `}
          media="(min-width: 0px)" />
        <img src={`${src}?q=100&w=${width}&fm=jpg&fl=progressive`} />
      </picture>
    )
  }
}

export default Picture;



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Picture.js